import { render, staticRenderFns } from "./wfTester.vue?vue&type=template&id=51c09834"
import script from "./wfTester.vue?vue&type=script&lang=js"
export * from "./wfTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports